module.exports = __webpack_public_path__ + "65545ef3a7ae55e71fd8473a12f0327f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/nick-doiron.jpg
 ** module id = 424
 ** module chunks = 0
 **/